export const truncateAddress = function (address) {
  let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
  if (!address) return "";
  return address.slice(0, length) + "..." + address.slice(-length);
};